import ManageTables from "./saga";

import loadable from "@loadable/component";
import { registerModals } from "modals";
import store from "rootStore";
import { permissionsType, configType } from "types/configTypes";

export const permissionKey = "table-management";

const getConfig = (permissions: permissionsType) => {
    const config: configType = {
        permissions: {
            create: false,
            delete: false,
            read: true,
            update: false,
        },
        routing: [],
        url: "",
    };

    store.injectSaga?.("ManageTables", ManageTables);

    config.permissions.update = true;
    config.permissions.delete = true;

    registerModals({
        TableModal: loadable(() => import("ui/Table/TableModal")),
    });


    return config;
};

export default getConfig;
